import { Inject } from '@odinjs/odin';

import { APPLICATION_ROUTES, Endpoint, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { FieldAPI, FormAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnAfterFetch, OnBeforeSubmit, OnCancel, OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService, msg } from '@philips-emr/tws-core/lib/services';

import BaseController from './BaseController';

interface Retorno {
  cdMatriculaEstipulanteAtual: string;
  body: Record<string, Value>;
}

@Controller({ fragment: 'alterar-matricula' })
class AlteracaoMatriculaController extends BaseController {

  @Inject('field-atual')
  private fieldAtual: FieldAPI;
  @Inject('toast-notification')
  private toastForm: ToastNotificationAPI;

  @OnMount({ target: 'panel-alterar-matricula' })
  onMountPanel(): void {

    const { nrSeqBeneficiario } = HistoryService.getCurrentRouteParams();
    this.context.set({ nrSeqBeneficiario });

  }

  @OnMount({ target: 'form-alterar-matricula' })
  onMountForm(event: MountEvent): void {
    const apiForm = event.target as unknown as FormAPI;
    const { nrSeqBeneficiario, nrSeqContrato } = HistoryService.getCurrentRouteParams();

    void HttpService.get<Record<string, Value>>(Endpoint.GET.SOLIC_ALT_MATRICULA_ABERTA, { nrSeqBeneficiario, nrSeqContrato }).then(response => {

      const { body: solicAberta } = response;

      if (solicAberta) {
        const { nrSeqSolicAlt } = solicAberta;
        this.context.set({ nrSeqSolicAlt });
        apiForm.setData(solicAberta);
        return;
      }

      this.getMatriculaAtual(apiForm);
    });
  }

  @OnBeforeSubmit({ target: 'form-alterar-matricula' })
  onSubmit(event: SubmitEvent): void {
    const { nrSeqBeneficiario, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    const { cdMatriculaEstipulanteNovo } = event.record;
    const { nrSeqSolicAlt } = this.context.getBulkData();
    const body = { nrSeqBeneficiario, cdMatriculaEstipulanteNovo, nrSeqSolicAlt };
    
    HttpService.post(Endpoint.POST.SOLIC_ALT_MATRICULA, { nrSeqBeneficiario, nrSeqContrato }, { body })
      .then(() => {

        ToastServiceStipulator.success(msg('stipuplator.alteracao.solicitada'));
        const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
        HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });

      })
      .catch(() => {
        this.toastForm.setVisible(true);
      });
  }

  @OnAfterFetch({ target: 'fetch-atual' })
  OnAfterFetch(event: FetchEvent): void {
    if(!event.data) {
      return;
    }
    const data = event.data as Retorno;
    const { cdMatriculaEstipulanteAtual } = data;

    if (!cdMatriculaEstipulanteAtual) {
      this.fieldAtual.setData({ cdMatriculaEstipulanteAtual: '-' });
    }
  }

  @OnCancel({ target: 'form-alterar-matricula' })
  onCancelForm(): void {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
  }

  @OnClose({ target: 'toast-notification' })
  onCloseToast(): void {
    this.toastForm.setVisible(false);
  }

  private getMatriculaAtual(apiForm: FormAPI): void {
    const { nrSeqBeneficiario, nrSeqContrato } = HistoryService.getCurrentRouteParams();

    void HttpService.get<Record<string, Value>>(Endpoint.GET.MATRICULA_ATUAL, { nrSeqBeneficiario, nrSeqContrato }).then(response => {

      const { body: matriculaAtual } = response as unknown as Retorno;
      const { cdMatriculaEstipulanteAtual } = matriculaAtual as unknown as Retorno;
      if (cdMatriculaEstipulanteAtual) {
        apiForm.setData(matriculaAtual);
        return;
      }

    });

  }
}

export default AlteracaoMatriculaController;
